import React, { Component } from 'react';
import { Popover, Button, Icon } from 'antd';
import FormList from '../../../basicElement/FormList.new.js';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import compareFn from '../Components/compareFn';
import moment from 'moment';

const dateFormate = 'YYYY-MM-DD';

class Form extends Component {
    handleChange = ({ value, key, type }) => {
        const { data } = this.props;
        if (key === 'companyName') {
            const { value: companyId, text: companyName } = value;
            data.companyId = companyId;
            data.companyName = companyName;
        } else if (key === 'bdName') {
            const { value: bdId, text: bdName } = value;
            data.bdId = bdId;
            data.bdName = bdName;
        } else if (key === 'makeDate') {
            data[key] = value;
            data.validDate = value ? moment(value).add(30, 'd').format(dateFormate) : '';
        } else {
            data[key] = value;
        }
        this.props.onChange(data);
    }

    getColumns = () => {
        const { mode, data, names, prevData } = this.props;

        // 字段属性配置
        const columns = [{
            key: 'serverType',
            type: 'text',
            attr: {
                name: names.serverType,
            }
        }, {
            key: 'studyId',
            type: 'input',
            attr: {
                name: names.studyId,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'companyName',
            type: 'searchRetrieve',
            attr: {
                name: names.companyName,
                keyword: 'companyName',
                placeholder: '输入公司名称检索',
                params: {limit: 20 },
                url: API_URL.competeCompany.queryCompany,
                config: { id: 'competingCompanyId', name: 'companyName', type: 'competeCompany' },
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'address',
            type: 'input',
            attr: {
                name: names.address,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'connector',
            type: 'input',
            attr: {
                name: names.connector,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'telephone',
            type: 'input',
            attr: {
                name: names.telephone,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'submitCompany',
            type: 'text',
            attr: {
                name: names.submitCompany,
            },
        }, {
            key: 'submitCompanyAddress',
            type: 'text',
            attr: {
                name: names.submitCompanyAddress,
            },
        }, {
            key: 'submitCompayTele',
            type: 'text',
            attr: {
                name: names.submitCompayTele,
            },
        }, {
            key: 'makeDate',
            type: 'datePicker',
            attr: {
                name: names.makeDate,
                style: { width: 240 },
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'baName',
            type: 'text',
            attr: {
                name: names.baName,
            },
        }, {
            key: 'bdName',
            type: 'searchRetrieve',
            attr: {
                name: names.bdName,
                keyword: 'keyword',
                placeholder: '输入姓名/工号检索',
                params: { limit: 20 },
                url: API_URL.team.userlist,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'approver',
            type: 'text',
            attr: {
                name: names.approver,
            },
        }, {
            key: 'validDate',
            type: 'text',
            attr: {
                name: names.validDate,
            },
        }, {
            key: 'salesforceId',
            type: 'input',
            attr: {
                name: names.salesforceId,
            },
            attrRules: {
                required: true,
            },
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, attr } = column;
                if (mode === 'compare') {
                    attr.value = compareFn(prevData, data, key);
                } else {
                    if (type === 'datePicker') {
                        attr.value = format('date', data[key]);
                    } else {
                        attr.value = data[key];
                    }
                    if (mode === 'note') {
                        const attrRules = column.attrRules || (column.attrRules = {});
                        attrRules.suffix = (
                            <Popover
                                title={
                                    <div>
                                        <div style={{ display: 'flex' }}>
                                            <strong>陶志红[200166] 2021-03-02 12:52</strong>
                                            <div style={{ marginLeft: 16 }}>
                                                <Icon type="check-square-o" />
                                                <Icon type="edit" />
                                                <Icon type="close-circle-o" />
                                            </div>
                                        </div>
                                        <p style={{ lineHeight: '24px' }}>
                                            计划书填写日期2021年3月2日
                                        </p>
                                    </div>
                                }
                                overlayClassName="quotation-popover"
                                content={<Button type="primary">添加备注</Button>}
                            >
                                <Icon type="message" className="icon-note" style={{ marginLeft: 16 }} />
                            </Popover>
                        );
                    }
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    render() {
        const { formRef, language, editable } = this.props;
        return (
            <FormList
                fieldWidth={400}
                language={language}
                editable={editable}
                columns={this.getColumns()}
                onChange={this.handleChange}
                ref={el => formRef(el)}
            />
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Cover/Form.js